import React, { useState, useRef } from "react";
import * as R from "ramda";
import FileIcon from "components/Atoms/FileIcon";
import FileViewer from "components/Global/Modals/FileViewer";
import FileViewerWrapper from "components/Global/Modals/FileViewer/Wrapper";
import LinearProgressWithLabel from "Portal/NewPortal/Shared/LinearProgressWithLabel";
import { noop, formatFileSize } from "utils/General";
import Popover from "@sessionboard/material-ui/Popover";
import DeletePopover from "components/Atoms/File/DeletePopover";
import CSSModules from "react-css-modules";
import css from "./styles.scss";
import cx from "classnames";

const FileRevision = ({
  file = {},
  cancelUpload = undefined,
  fileUploadUploadHasFinished = true,
  value = 50,
  deleteFile = noop,
  isPreUploading = false,
  showModal = noop,
  files = [],
  loadingSavingFile = false
}) => {
  const {
    filename = undefined,
    mimetype = undefined,
    size = undefined,
    url = undefined
  } = file;
  const fileType = mimetype ? mimetype.split("/").pop() : "";

  const [showDeletePopover, setShowDeletePopover] = useState(false);
  const fileRef = useRef(null);

  const handleRequestClose = () => {
    setShowDeletePopover(false);
  };

  const viewFile = () => {
    window.open(url, "_blank");
  };

  const onDelete = e => {
    e.stopPropagation();
    handleRequestClose();
    deleteFile();
  };

  const handleShowDeletePopover = e => {
    e.stopPropagation();
    setShowDeletePopover(true);
    fileRef.current = e.currentTarget;
  };

  const handleViewFile = () => {
    const filesToView = isPreUploading ? [file] : files;
    showModal({
      content: (
        <FileViewer
          start={filesToView.indexOf(file)}
          files={filesToView}
          isReadOnly
        />
      ),
      wrapper: FileViewerWrapper
    });
  };

  return (
    <div
      ref={fileRef}
      style={{
        width: "100%",
        height: "100%",
        padding: "12px",
        background: "#F8F8F8",
        borderRadius: "4px",
        border: "1px #E7E6EA dashed",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        gap: "12px",
        display: "flex"
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "12px",
          background: "white",
          width: "100%",
          padding: "12px"
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            gap: "8px",
            alignItems: "center"
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              gap: "8px",
              cursor: fileUploadUploadHasFinished ? "pointer" : "default",
              flex: 1
            }}
            onClick={() => {
              if (fileUploadUploadHasFinished) {
                handleViewFile();
              } else {
                noop();
              }
            }}
          >
            <FileIcon size={20} mimetype={mimetype} />
            <div className={css.fileInfo}>
              <div className={css.fileName}>{filename}</div>
              <div className={css.fileTypeContainer}>
                <div>{R.toUpper(fileType)}</div>
                {size && <div>{formatFileSize(size)}</div>}
              </div>
            </div>
          </div>
          <div className={css.actions}>
            {isPreUploading &&
              fileUploadUploadHasFinished &&
              !loadingSavingFile && (
                <i
                  className={cx("material-icons", css.deleteIcon)}
                  onClick={handleShowDeletePopover}
                >
                  delete_forever
                </i>
              )}

            {url && (
              <i
                className={cx("material-icons", css.downloadIcon)}
                onClick={viewFile}
              >
                file_download
              </i>
            )}
          </div>
        </div>

        {!fileUploadUploadHasFinished && (
          <div>
            <LinearProgressWithLabel
              value={value}
              cancel={() => cancelUpload()}
            />
          </div>
        )}

        <Popover
          open={showDeletePopover}
          anchorEl={fileRef.current}
          anchorOrigin={{ horizontal: "middle", vertical: "bottom" }}
          transformOrigin={{ horizontal: "middle", vertical: "bottom" }}
          onClose={handleRequestClose}
        >
          <DeletePopover delete={onDelete} cancel={handleRequestClose} />
        </Popover>
      </div>
    </div>
  );
};

export default CSSModules(FileRevision, css);
